import React, { useRef } from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from './HeroSection';
import WorkflowSteps from './WorkflowSteps';
import FeatureSection from './FeatureSection';
import UniqueFeatures from './UniqueFeatures';
import PartnersSection from '../Home/PartnersSection';
import ModulesSection from './ModulesSection';
import BenefitsSection from './BenefitsSection';
import SEO from '../../components/common/SEO';

const AboutPage = () => {
  const workflowRef = useRef(null);

  const handleLearnMore = () => {
    workflowRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="About"
        description="Discover our heritage, our passion, and the exceptional journey of Elixir. Rooted in tradition, crafted with passion - learn about our commitment to quality and the Mediterranean terroir."
        keywords="
          Elixir honey story,
          Tunisian beekeeping tradition,
          Mediterranean honey heritage,
          artisanal honey production,
          traditional beekeeping methods,
          honey quality commitment,
          Adami Apiculture,
          honey craftsmanship
        "
      />
      <Header />
      <main className="flex-grow">
        <HeroSection
          title="Our Story, Our Passion, Your Elixir"
          description="Discover our heritage, our passion, and the exceptional journey of Elixir."
          secondaryCTA={{
            text: 'Explore Our Story',
            onClick: handleLearnMore,
          }}
        />
        <div ref={workflowRef}>
          <WorkflowSteps />
        </div>
        <FeatureSection />
        <UniqueFeatures />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
